<template>
  <div v-if="lists.arr !== undefined">
    <headers />
    <mytop />
    <div class="top">个人中心  /  我的班级  / {{lists.arr.classname}}</div>
    <div class="content">
      <div class="content-t">
       		<img :src="lists.arr.logo">
      </div>
      <div class="content-b">
        {{lists.arr.classname}}
      </div>
      <div class="toptitle">
        <div class="toptitlecon">全部课程</div>
      </div>
      <div class="kccon">

        <div class="kccontent" v-for="item in lists.arr.course">
          <router-link target="_blank"
                       :to="{path:'/detailsclass',query:{id:item.course_id}}">
          <div class="kccontent-t"><img :src="item.course_imgUrl"></div>
          <div class="kccontent-b">{{item.course_name}}</div>
          </router-link>
        </div>

      </div>
      <div class="pageing"  v-if="lists.arr != undefined && lists.arr.length != 0 && lists.total_pages>1">
      <span @click="pageindex">首页</span>
      <el-pagination
        small
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :background="true"
        :total="lists.total_pages==null?1:lists.total_pages"
        :page-size="1"
        @current-change="currentchange"
        :current-page="page"
      ></el-pagination>
      <span @click="pageend">尾页</span>
    </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import mytop from "@/components/mytop.vue";

import utilFile from "@/ace/ace.js";
import {
  Pagination,
  Row,
  Col,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Tabs, TabPane, Message
  
} from "element-ui";
export default {
  components: {
    headers,
    footers,
    mytop,
    [Pagination.name]: Pagination,
    [Row.name]: Row,
    [Col.name]: Col,
    [Menu.name]: Menu,
    [Submenu.name]: Submenu,
    [MenuItemGroup.name]: MenuItemGroup,
    [MenuItem.name]: MenuItem,
      [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Message.name]: Message,
  },
  data() {
    return {
      page: 1,
      lists:{}
    };
  },
  watch: {

    page (newvalue) {
      this.page = newvalue;
      this.get_class();
    }
  },
  methods: {

    get_class() {
      var data = utilFile.encrypt(
              JSON.stringify({
                page: this.page,
                class_id: this.$route.query.id
              })
      );
      var that =this;
      this.$axios({
        method: "post",
        url: `/api/user.myclasslistdetail?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {

        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        }else if(res.data.code !='200' ){
          this.$router.push({
            name: "soncourse"
          });
        } else {

          if (res.data.data != undefined) {
            var totaldata = JSON.parse(utilFile.decrypt(res.data.data));
            console.log(totaldata);
            that.lists = totaldata;
          }

        }
      });
    }

  ,pageindex() {
    this.page = 1;
  }
  ,currentchange(page) {
    this.page = page;
  }
  ,pageend() {
    this.page = this.lists.total_pages;
  },

  },
  mounted() {
      this.get_class();
  }
};
</script>

<style scoped>
@import "~@/assets/css/my.css";
.top{
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #999;
}
.content{
  width: 1200px;
  background-color: #fff;
  padding-top: 30px;
  border-radius: 10px;
  margin: 0 auto;
}
.content-t{
  width: 100%;
  height: 102px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-t img{
  width: 102px;
  height: 102px;
}
.content-b{
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #1a1a1a;
}
.toptitle{
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  height: 50px;
  display: flex;
  justify-content: flex-start;
}
.toptitlecon{
   height: 50px;
   line-height: 50px;
   border-bottom: 1px solid #38a0ff;
   font-size: 16px;
   color: #38a0ff;
  }
  .kccon{
    width: 100%;
    padding: 0 25px;
    box-sizing: border-box;
    display: flex;
    flex-flow: row wrap;
  }
  .kccontent{
    width: 210px;
    margin: 0 10px;
    height: 155px;
    margin-top: 30px;
    position: relative;
  }
  .kccontentdw{
    width: 70px;
    height: 35px;
    line-height: 35px;
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: rgba(90, 90, 90, .6);
    font-size: 14px;
    color: #fff;

  }
  .kccontent-t{
    width: 100%;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
  }
  .kccontent-b{
    width: 100%;
    height: 50px;
    margin-top: 5px;
    font-size: 14px;
    color: #333333;
  }
</style>